import { render } from "./LanguageStringsImportModal.vue?vue&type=template&id=ea9b5164&scoped=true"
import script from "./LanguageStringsImportModal.vue?vue&type=script&lang=js"
export * from "./LanguageStringsImportModal.vue?vue&type=script&lang=js"

import "./LanguageStringsImportModal.vue?vue&type=style&index=0&id=ea9b5164&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea9b5164"]])

export default __exports__